import { Banco } from "./banco";
import { Ciudad } from "./ciudad";
import { CuentaContable } from "./cuenta-contable";

export class CuentaBancaria{
    public constructor(
        public nombre:String = "",
        public banco_id:String = "",
        public tipo_cta:string = "",
        public numero_cta:String = "",
        public ciudad_id:String = null,
        public cuenta_contable_id: String = "",
        public status:String="",
        public empresa_id:String = "",
        public usuario_id:String = null,

        public banco : Banco = new Banco(),
        public cuentacontable : CuentaContable = new CuentaContable(),
        public ciudad:Ciudad = new Ciudad(),

    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cuenta-bancaria.ts